export default "__VITE_ASSET__CFaL2MjM__"